import RFFInputField from '../../form/RFFInputField';
import RFFSelectField from '../../form/RFFSelect';
import RFFDateSelect from '../../form/RFFDateSelect';
import RFFRadio from '../../form/RFFRadio';
import RFFNumberInputField from '../../form/RFFNumberInputField';
import {
  maxLength,
  isUnformattedNSNorNIIN,
  maxValue,
} from '../../../utils/validationUtils';

const createOptions = obj => {
  const keys = Object.keys(obj);

  const options = keys.map(key => ({ text: obj[key], value: key }));
  return options;
};
const methods = {
  casting: 'Casting',
  investmentCasting: 'Investment Casting',
  investmentCastingTooling: 'Investment Casting Tooling',
  sandCasting: 'Sand Casting',
  permanentMoldCasting: 'Permanent Mold Casting',
  semiPermanentMoldCasting: 'Semi Permanent Mold Casting',
  dieCasting: 'Die Casting',
  centrifugalCasting: 'Centrifugal Casting',
  plasterCasting: 'Plaster',
  vProcess: 'V-Process',
  vacuumMeltCapabilities: 'Vacuum Melt Capabilities',
  squeezeSemiSolid: 'Squeeze/Semi-Solid',
  unspecified: 'Unspecified',
  forging: 'Forging',
  closedDie: 'Closed Die',
  openDie: 'Open Die',
  coldForging: 'Cold Forging',
  upsetForging: 'Upset Forging',
  rolledRing: 'Rolled Ring',
  otherMethodsAsSpecified: 'Other Methods As Specified',
};
const materials = {
  alloySteel: 'Alloy Steel',
  aluminum: 'Aluminum',
  berylliumCopper: 'Beryllium Copper',
  bronze: 'Copper (Brass/Bronze)',
  carbonSteel: 'Carbon Steel',
  cobalt: 'Cobalt',
  copper: 'Copper',
  highTempAlloy: 'High Temp Alloy',
  iron: 'Iron',
  lead: 'Lead',
  magnesium: 'Magnesium',
  microAlloy: 'Micro Alloy',
  MMC: 'Metal Matrix Composites',
  nickel: 'Nickel',
  other: 'Other Non-Ferrous',
  steel: 'Steel',
  stainlessSteel: 'Stainless Steel',
  superalloys: 'Superalloys',
  titanium: 'Titanium',
  toolSteel: 'Tool Steel',
  unspecified: 'Unspecified',
  zinc: 'Zinc'
};

const secondaryProcesses = {
  assembly: 'Assembly',
  dimensionalInspection: 'Dimensional Inspection',
  engineeringDesign: 'Engineering & Design',
  heatTreat: 'Heat Treating',
  liguidPentrant: 'Liquid Penetrant',
  magneticParticle: 'Magnetic Particle',
  painting: 'Painting',
  patternShop: 'Pattern Shop',
  radiography: 'Radiography',
  roughMachining: 'Rough/Finish Machining',
  surfaceTreatments: 'Surface Treatments',
  welding: 'Welding',
};

export const dates = [
  {
    name: 'quoteDueDate',
    label: 'Quote Due Date',
    isRequired: true,

    component: RFFDateSelect,
  },
  {
    name: 'sampleDueDate',
    label: 'Sample Due Date',
    type: 'text',

    component: RFFDateSelect,
  },
  {
    name: 'orderDueDate',
    label: 'Order Due Date',
    isRequired: true,
    type: 'text',

    component: RFFDateSelect,
  },
];

export const column1 = [
  {
    name: 'description',
    label: 'RFQ Description',
    component: RFFInputField,
    isRequired: true,
    placeholder: "No more than 50 characters",
    validate: maxLength(50),
    type: 'text',
    labelCol: { md: 4 },
  },

  {
    name: 'niin',
    label: 'NSN/NIIN',
    component: RFFInputField,
    numberFormat: '',
    validate: isUnformattedNSNorNIIN,
    type: 'text',
    labelCol: { md: 4 },
  },
  {
    name: 'partDesc',
    label: 'Part Description',
    component: RFFInputField,
    placeholder: "No more than 50 characters",
    validate: maxLength(50),
    type: 'text',
    labelCol: { md: 4 },
  },
  {
    name: 'qty',
    isRequired: true,
    label: 'Total Quantity Required',
    component: RFFNumberInputField,
    numberFormat: '',
    thousandSeparator: true,
    validate: maxValue(99999999.999),
    type: 'text',
    labelCol: { md: 4 },
  },
  {
    name: 'castingWt',
    label: 'Casting weight',
    component: RFFNumberInputField,
    numberFormat: '',
    thousandSeparator: true,
    placeholder: 'Between 0.000 and 99,999,999.999',
    validate: maxValue(99999999.999),
    type: 'text',
    labelCol: { md: 4 },
  },
  {
    name: 'toolingDesc',
    label: 'Tooling Description',
    component: RFFInputField,
    placeholder: "No more than 50 characters",
    validate: maxLength(50),
    type: 'text',
    labelCol: { md: 4 },
  },
  {
    name: 'prefCastProc',
    label: 'Preferred Casting Process',
    component: RFFSelectField,
    options: createOptions(methods),
    labelCol: { md: 4 },
  },

  {
    name: 'reqCastSpec',
    label: 'Required Casting Specifications',
    component: RFFInputField,
    placeholder: "No more than 50 characters",
    validate: maxLength(50),
    type: 'text',
    labelCol: { md: 4 },
  },
  {
    name: 'testingRqmts',
    label: 'Testing Requirements',
    component: RFFInputField,
    placeholder: "No more than 50 characters",
    validate: maxLength(50),
    labelCol: { md: 4 },

    type: 'text',
  },
  {
    name: 'rfqMaterial',
    label: 'Material/Commercial Designation',
    labelCol: { md: 4 },

    component: RFFSelectField,
    options: createOptions(materials),
  },
  {
    name: 'comment',
    label: 'Comments',
    labelCol: { md: 4 },

    component: RFFInputField,
    placeholder: "No more than 2000 characters",
    validate: maxLength(2000),
    type: 'textarea',
  },
  // need this
];
export const column2 = [
  {
    name: 'solNum',
    label: 'Solicitation Number',
    labelCol: { md: 4 },
    placeholder: "No more than 21 characters",
    validate: maxLength(21),
    component: RFFInputField,
    type: 'text',
  },
  {
    name: 'partNum',
    labelCol: { md: 4 },
    placeholder: "No more than 50 characters",
    validate: maxLength(50),
    label: 'Part Number',
    component: RFFInputField,
    type: 'text',
  },
  {
    name: 'drawingNums',
    labelCol: { md: 4 },

    label: 'Drawing Numbers',
    component: RFFInputField,
    placeholder: "No more than 50 characters",
    validate: maxLength(50),
    type: 'text',
    toolTip: 'Drawing Numbers is limited to 50 characters',
    maxLength: 50,
  },
  {
    name: 'releaseQty',
    labelCol: { md: 4 },

    label: 'Release Quantities',
    component: RFFNumberInputField,
    numberFormat: '',
    thousandSeparator: true,
    placeholder: 'Between 0.000 and 99,999,999.999',
    validate: maxValue(99999999.999),
    type: 'text',
  },
  {
    name: 'toolingAvailable',
    labelCol: { md: 4 },

    label: 'Tooling Available?',
    component: RFFRadio,
    type: 'Radio',

    options: [{ text: 'Yes', value: '1' }, { text: 'No', value: '0' }],
  },
  {
    name: 'machiningReq',
    labelCol: { md: 4 },

    label: 'Machining Required?',
    component: RFFRadio,
    type: 'Radio',

    options: [{ text: 'Yes', value: '1' }, { text: 'No', value: '0' }],
  },
  {
    name: 'sampleAvailable',
    labelCol: { md: 4 },

    label: 'Sample Part Available',
    component: RFFRadio,
    type: 'Radio',

    options: [{ text: 'Yes', value: '1' }, { text: 'No', value: '0' }],
  },
  {
    name: 'secOpsReq',
    labelCol: { md: 4 },

    label: 'Other Secondary Operations Required',
    component: RFFSelectField,
    options: createOptions(secondaryProcesses),
  },
];
export const array = [
  {
    name: 'nda',
    label: 'nda',
    labelCol: { md: 4 },

    component: RFFSelectField,
    options: createOptions(materials),
  },
];



// WEBPACK FOOTER //
// ./src/components/forms/EditRFQForm/formConfig.jsx